import Extra from 'components/form/ExtraRadioButton';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  actions as shipmentActions,
  selectors as shipmentSelectors,
} from 'state/shipments';
import { actions as errorActions } from 'state/errors';
import { selectors as orderSelectors } from 'state/order';
import { constants } from 'utils/extras';
import PropTypes from 'prop-types';
import useIsHandlingAllowed from 'hooks/useIsHandlingAllowed';
import useFormState from 'hooks/useFormState';

const HandlingExtra = ({ className, stopType, shipmentKey }) => {
  const isEditing = useSelector(orderSelectors.getIsEditing);
  const [isSelected, setIsSelected] = useState(isEditing);
  const dispatch = useDispatch();
  const extras = useSelector((state) =>
    shipmentSelectors.getShipmentExtras(state, shipmentKey)
  );
  const [wasHandlingAllowed, setWasHandlignAllowed] = useState(true);

  const handlingExtraType = useMemo(
    () => constants.HANDLES_BY_STOPTYPE[stopType],
    [stopType]
  );

  const checked = useMemo(
    () => extras.some((extra) => extra === handlingExtraType),
    [extras, handlingExtraType]
  );

  const fieldType = `handling`;
  const stopId = `${shipmentKey}-${stopType}`;
  const { fieldHasError } = useFormState(stopId, fieldType, isSelected);

  const isHandlingAllowed = useIsHandlingAllowed();

  const handleExtra = useCallback(() => {
    dispatch(
      shipmentActions.changeExtras({
        shipmentKey,
        stopType,
        extra: handlingExtraType,
      })
    );
  }, [dispatch, shipmentKey, stopType, handlingExtraType]);

  const reset = useCallback(() => {
    if (checked) {
      handleExtra();
    }
    setIsSelected(false);
  }, [checked, handleExtra]);

  const handleChange = useCallback(
    (newValue) => {
      setIsSelected(true);
      // only touch state extras when needed
      if ((checked && newValue === false) || (!checked && newValue === true)) {
        handleExtra();
      }
    },
    [checked, handleExtra]
  );

  //   handling allowed
  useEffect(() => {
    if (isHandlingAllowed && !wasHandlingAllowed) {
      reset();
      setIsSelected(false);
      setWasHandlignAllowed(true);
    }
    if (!isHandlingAllowed) {
      const key = `${shipmentKey}_${stopType}`;
      reset();
      setIsSelected(true);
      dispatch(errorActions.removeError([key]));
      setWasHandlignAllowed(false);
    }
  }, [
    isHandlingAllowed,
    reset,
    wasHandlingAllowed,
    shipmentKey,
    stopType,
    dispatch,
  ]);

  return (
    <Extra
      stopId={stopId}
      className={className}
      handleChange={handleChange}
      stopType={stopType}
      isSelected={isSelected}
      checked={checked}
      isHandlingAllowed={isHandlingAllowed}
      hasError={fieldHasError}
    />
  );
};

HandlingExtra.propTypes = {
  className: PropTypes.string,
  stopType: PropTypes.string.isRequired,
  shipmentKey: PropTypes.string.isRequired,
};

export default HandlingExtra;
